/**
 * converts a given string to a translation key
 * @param {String} key - to convert
 * @param {Object} options - an object with specific parameters
 * @param {Boolean} options.dot
 * @param {Boolean} options.dash
 * @param {Boolean} options.bracket
 * @param {Boolean} options.slash
*/

export const makeKey = function (key) {
  var _key$toLowerCase$trim, _convertedKey, _convertedKey2;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  let convertedKey = key === null || key === void 0 || (_key$toLowerCase$trim = key.toLowerCase().trim()) === null || _key$toLowerCase$trim === void 0 ? void 0 : _key$toLowerCase$trim.replaceAll(/[^a-z0-9]/g, '_');

  //remove plenty underscores
  convertedKey = (_convertedKey = convertedKey) === null || _convertedKey === void 0 ? void 0 : _convertedKey.replaceAll(/__+/g, '_');

  //remove plenty underscore at the end
  convertedKey = (_convertedKey2 = convertedKey) === null || _convertedKey2 === void 0 ? void 0 : _convertedKey2.replace(/_+$/, '');
  return convertedKey;
};